import React from 'react';
import HeaderAndNavbar from '../../components/headerAndNavbar/HeaderAndNavbar'
import Footer from '../../components/footer/Footer'

const Kompani = () => {
    return (
        <div>
            <HeaderAndNavbar />
            <div className='container mt-5 mb-5 pb-5'>
                <h1 className='mb-4 text-center mt-5'>Kompani</h1>
            <p className='mb-5'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
        </div>
        <Footer/>
        </div>
    );
};

export default Kompani;